'use client';

import * as React from 'react';

export function useDesktop(): { isDesktop: boolean; mounted: boolean } {
  const [isDesktop, setIsDesktop] = React.useState(false);
  const [mounted, setMounted] = React.useState(false);

  React.useEffect(() => {
    setMounted(true);
    const checkDesktop = (): void => {
      setIsDesktop(window.innerWidth >= 768);
    };
    checkDesktop();
    window.addEventListener('resize', checkDesktop);
    return () => {
      window.removeEventListener('resize', checkDesktop);
    };
  }, []);

  return { isDesktop, mounted };
}
